import { defineMessages } from 'react-intl-next';

export const i18n = defineMessages({
	buttonLabel: {
		id: 'search-page.navigation.search.work-items',
		defaultMessage: 'Search work items',
		description: 'Button to navigate to New Issue Navigator (NIN) to search for work items',
	},
});
